import { connect } from 'react-redux';

import type { State } from '../../../reducers';
import type { TableColumn } from '../../enums/TableColumn';
import { ConnectedTableHead } from '../header/TableHead';
import { getCurrentColumns } from './columnService';

const mapStateToProps = (state: State): { columns: TableColumn[] } => ({
    columns: getCurrentColumns(state), // getVisibleColumns(state),
});

export const DrivingTimesTableHeadContainer = connect(mapStateToProps)(ConnectedTableHead);
